// symetric encryption

const aesEncryptString = async (theapp, settings_entry, plaintext) => {
	let mvcmywidget = theapp.getMvcMyWidget();
	var rootsessionuuid = await theapp.getRootSessionUUID();

	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;

	let result;

	try {
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		let context = {};
		await theapp.getCurrencyContext(context, settings_entry);

		let currentcard = context.currentcard;

		if (!currentcard)
			return;

		result = await mvcmywidget.aesEncryptString(rootsessionuuid, walletuuid, currentcard.uuid, plaintext);
	}
	catch(e) {
		console.log('exception in aesEncryptString: ' + e);
	}

	return result;
}

const aesDecryptString = async (theapp, settings_entry, cyphertext) => {
	let mvcmywidget = theapp.getMvcMyWidget();
	var rootsessionuuid = await theapp.getRootSessionUUID();

	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;

	let result;

	try {
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		let context = {};
		await theapp.getCurrencyContext(context, settings_entry);

		let currentcard = context.currentcard;

		if (!currentcard)
			return;

		result = await mvcmywidget.aesDecryptString(rootsessionuuid, walletuuid, currentcard.uuid, cyphertext);
	}
	catch(e) {
		console.log('exception in aesDecryptString: ' + e);
	}

	return result;
}

// asymetric encryption

const rsaEncryptString = async (theapp, settings_entry, recipientrsapublickey, plaintext) => {
	let mvcmywidget = theapp.getMvcMyWidget();
	var rootsessionuuid = await theapp.getRootSessionUUID();

	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;

	let result;

	try {
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		let context = {};
		await theapp.getCurrencyContext(context, settings_entry);

		let currentcard = context.currentcard;

		if (!currentcard)
			return;

		result = await mvcmywidget.rsaEncryptString(rootsessionuuid, walletuuid, currentcard.uuid, recipientrsapublickey, plaintext);
	}
	catch(e) {
		console.log('exception in rsaEncryptString: ' + e);
	}

	return result;
}

const rsaDecryptString = async (theapp, settings_entry, senderrsapublickey, cyphertext) => {
	let mvcmywidget = theapp.getMvcMyWidget();
	var rootsessionuuid = await theapp.getRootSessionUUID();

	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;

	let result;

	try {
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		let context = {};
		await theapp.getCurrencyContext(context, settings_entry);

		let currentcard = context.currentcard;

		if (!currentcard)
			return;

		result = await mvcmywidget.rsaDecryptString(rootsessionuuid, walletuuid, currentcard.uuid, senderrsapublickey, cyphertext);
	}
	catch(e) {
		console.log('exception in rsaDecryptString: ' + e);
	}

	return result;
}

// signature

const signString = async (theapp, settings_entry, plaintext) => {
	let mvcmywidget = theapp.getMvcMyWidget();
	var rootsessionuuid = await theapp.getRootSessionUUID();

	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;

	let result;

	try {
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		let context = {};
		await theapp.getCurrencyContext(context, settings_entry);

		let currentcard = context.currentcard;

		if (!currentcard)
			return;

		result = await mvcmywidget.signString(rootsessionuuid, walletuuid, currentcard.uuid, plaintext);
	}
	catch(e) {
		console.log('exception in signString: ' + e);
	}

	return result;
}


const validateStringSignature = async (theapp, settings_entry, address, plaintext, signature) => {
	let mvcmywidget = theapp.getMvcMyWidget();
	var rootsessionuuid = await theapp.getRootSessionUUID();

	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;

	let result;

	try {
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		result = await mvcmywidget.validateStringSignature(rootsessionuuid, walletuuid, address, plaintext, signature);
	}
	catch(e) {
		console.log('exception in validateStringSignature: ' + e);
	}

	return result;
}



export {aesEncryptString, aesDecryptString, rsaEncryptString, rsaDecryptString, signString, validateStringSignature};